<template>
  <div
    id="app"
    class="o-typography"
    :class="{ 'is-loading': loading }"
  >
    <router-view class="o-page o-page--no-footer"></router-view>
    <ui-modal></ui-modal>
  </div>
</template>

<script>
  import { UiModal } from '@/index/components';
  import { layoutMixin } from '@/index/shared/mixins';

  export default {
    components: {
      UiModal,
    },
    mixins: [
      layoutMixin,
    ],
  };
</script>
